import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';
import { CustomListBaseComponent } from '../../../ui-framework/core-controls/custom-list-base/custom-list-base.component';
import { ApiDataService } from '../../../data-services/api-data.service';
import { SelectionListComponent } from "../../../ui-framework/core-controls/selection-list-base/selection-list.component";
import { ColDef } from "ag-grid-community";
import { Training } from '../../../data-services/api-models/tms-service-models';

@Component({
  selector: 'app-training-selection-list',
  imports: [SelectionListComponent],
  templateUrl: './training-selection-list.component.html',
  styleUrl: './training-selection-list.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TrainingSelectionListComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrainingSelectionListComponent extends CustomListBaseComponent<Training> implements ControlValueAccessor {

  // private readonly popupColumns: ColDef<Training>[] = [
  //     {
  //       field: 'description', headerName: 'Name', flex: 2
  //     }
  //   ];
  @Input() multiple = false; // ✅ Make sure this exists
  private readonly popupColumns: ColDef<Training>[] = [
    {
      headerName: 'Description',
      flex: 1,
      minWidth: 200,
      tooltipValueGetter: (params) =>
        `${params.data?.code} - ${params.data?.description}`,
      valueGetter: (params) =>
        `${params.data?.code} - ${params.data?.description}`,
    }
  ];

  constructor(private readonly apiDataService: ApiDataService) {
    super();

  }

  private setupConfig() {
    this.currentConfig.displayFormatter = (r) => this.displayFormatter(r);
    this.currentConfig.label = 'Training Name';
    this.currentConfig.listColumns = this.popupColumns;
    this.currentConfig.dataSource = () => this.getMasters()
    this.currentConfig.popupSize = 'Medium';
    this.currentConfig.multipleSelection = this.multiple;
    this.currentConfig.rowFilter = (param: Training) => true
    this.refreshConfig();
  }

  ngOnInit() {
    this.setupConfig();
  }

  private getMasters(): Observable<Training[]> {
    return this.apiDataService.tmsMastersApi.getTraining()
  }



  private readonly displayFormatter = (item: Training) => `${item?.code}- ${item?.description}`;

}
